import { FaqList } from '@/components/landing/FaqList';
import { Cta } from '@/components/landing/Cta';
import { useT } from '@/lib/useLang';

export function FaqPage() {
  const t = useT();

  return (
    <>
      <section className="nz-page nz-page--wide">
        <div className="nz-eyebrow">FAQ</div>
        <h1 className="nz-page__title">{t.faqPageTitle}</h1>
        <p className="nz-lead">{t.faqPageIntro}</p>

        {t.faqGroups.map((group, index) => (
          <div className="nz-faq-group" key={group.title}>
            <h2 className="nz-faq-group__title">{group.title}</h2>
            <FaqList items={group.items} idPrefix={`nz-faq-${index}`} openFirst={false} />
          </div>
        ))}
      </section>

      <Cta />
    </>
  );
}
